export default {
  errorsRootKey: 'trackingSources',
  resource: 'calltrackings/tracking-sources',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
